export default "__VITE_ASSET__CE6MlwZQ__"